import { FingerprintjsWrapper } from '../modules/fingerprintjs/FingerprintjsWrapper';
import { CheckboxValue, RegistrationProtocol } from '../../user/registrationProtocol';
import { FormHandlers } from '../modules/formHandlers';
import { registrationV4 } from '../modules/registration_popup/registrationV4';
import { JRpcResponse } from '../modules/jsonRpc/jsonRpcResponseFactory';

async function registerThroughHubSendRequest(form: JQuery): Promise<JRpcResponse<{}>> {
    try {
        const confidenceScore = await FingerprintjsWrapper.getConfidenceScore();
        const emailField = form.find('input[type=email]');
        const email: string = ((emailField.val() as string) ?? '').trim();
        const state = form.find('[name=state]').val();
        const lp = form.find('[name=lp]').val() as number;
        const csrftoken = form.find('[name=csrftoken]').val() as number;
        const consentState: boolean = form.find('[name=receive_consent]')
            .prop('checked') as boolean;

        const regData: RegistrationProtocol = {
            confidence: confidenceScore,
            csrftoken,
            email,
            lp,
            receive_consent: (consentState ? 'on' : 'off') as CheckboxValue,
            state
        };

        switch (Number(lp)) {
            case 4:
                const emailConfirmField = form.find('input[type=email_confirm]');
                const emailConfirm: string = ((emailConfirmField.val() as string) ?? '').trim();
                regData.email_confirm = emailConfirm;
                break;
            case 2:
                break;
            case 1:
            case 3:
            default:
                const passwordField = form.find('input[type=password]');
                const password: string = ((passwordField.val() as string) ?? '').trim();
                regData.password = password;
        }

        return await registrationV4(regData);
    } catch (exception) {
        console.log('Exception on register user through API', exception);
        window.Sentry.captureException(exception);
        throw exception;
    }
}

export function initRegistrationFormHandler() {
    FormHandlers.registerSendRequestHandler('registration_through_hub_send_request', registerThroughHubSendRequest);
}
